// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"TempHotelResults_iconSync__7kTt5","fa-spin":"TempHotelResults_fa-spin__2b2ZZ"};